import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const COUNTRIES = [
  ["+961", "Lebanon"], ["+971", "UAE"], ["+966", "Saudi Arabia"], ["+974", "Qatar"], ["+965", "Kuwait"],
  ["+973", "Bahrain"], ["+968", "Oman"], ["+962", "Jordan"], ["+20", "Egypt"], ["+90", "Turkey"],
  ["+1", "USA / Canada"], ["+44", "UK"], ["+33", "France"], ["+49", "Germany"], ["+34", "Spain"],
  ["+39", "Italy"], ["+31", "Netherlands"], ["+46", "Sweden"], ["+41", "Switzerland"], ["+61", "Australia"],
  ["+64", "New Zealand"], ["+81", "Japan"], ["+82", "South Korea"], ["+86", "China"], ["+91", "India"],
  ["+92", "Pakistan"], ["+55", "Brazil"], ["+52", "Mexico"], ["+27", "South Africa"], ["+234", "Nigeria"],
  ["+254", "Kenya"], ["+7", "Russia / Kazakhstan"], ["+380", "Ukraine"], ["+48", "Poland"], ["+30", "Greece"],
  ["+357", "Cyprus"], ["+963", "Syria"], ["+964", "Iraq"], ["+212", "Morocco"], ["+216", "Tunisia"],
];

export function isValidE164(phone) {
  return /^\+[1-9]\d{6,14}$/.test((phone || "").replace(/[\s-]/g, ""));
}

// Emits full E.164 via onChange(fullNumber, countryName)
export const PhoneInput = ({ value, onChange, testid = "phone-input" }) => {
  const initial = COUNTRIES.find(([code]) => (value || "").startsWith(code));
  const [code, setCode] = useState(initial?.[0] || "+961");
  const [national, setNational] = useState(initial ? (value || "").slice(initial[0].length) : "");

  const emit = (c, n) => {
    const digits = n.replace(/\D/g, "");
    onChange(digits ? `${c}${digits}` : "", COUNTRIES.find(([cc]) => cc === c)?.[1] || "");
  };

  return (
    <div className="flex gap-2">
      <Select value={code} onValueChange={(c) => { setCode(c); emit(c, national); }}>
        <SelectTrigger className="bg-[#07080B] border-white/10 w-[130px] h-11 shrink-0" data-testid={`${testid}-country`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="bg-[#101219] border-white/10 max-h-72">
          {COUNTRIES.map(([c, name]) => (
            <SelectItem key={c} value={c} className="focus:bg-white/5">{c} {name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        type="tel"
        inputMode="numeric"
        value={national}
        onChange={(e) => { const n = e.target.value.replace(/[^\d\s]/g, ""); setNational(n); emit(code, n); }}
        placeholder="3 123 456"
        className="bg-[#07080B] border-white/10 h-11 flex-1"
        data-testid={testid}
      />
    </div>
  );
};
